import { useQuery } from '@tanstack/react-query';

import { notificationKeys } from './notificationKeys';

import { api } from '@/lib/api';

/**
 * How often the bell asks again, in milliseconds.
 *
 * Warning: polling, not a socket. A per-user socket room already exists for
 * presence and could carry this, but `socket.io-client` costs ~15 Ko gzip
 * against a 160 Ko budget — too much for a badge.
 *
 * @see docs/features/notifications.md
 */
const POLL_MS = 60_000;

/**
 * The number on the bell.
 *
 * Warning: its own module, apart from the page's hooks. `AppLayout` mounts
 * this on every authenticated screen, so anything sharing a file with it lands
 * in the initial chunk — the list, the preferences and the mutations do not
 * belong there.
 *
 * @returns The React Query result holding the unread count.
 */
export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unread(),
    queryFn: () => api.notifications.unreadCount(),
    refetchInterval: POLL_MS,
    // A badge that only refreshes on a timer is stale the moment somebody
    // comes back to the tab, which is exactly when they look at it.
    refetchOnWindowFocus: true,
  });
}
